// TODO: mock enum. will most likely be moved to api
export enum Role {
  Admin = 'Admin',
  Supervisor = 'Supervisor',
  Operator = 'Operator',
}
